import { Component } from "@angular/core";
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';

class State extends BaseState
{
    DataSourceName: string;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-commonsettings',
    templateUrl: './commonsetting.component.html'
})

export class CommonSettingComponent extends BasePageComponent<BaseEntity, State>
{
    override ModuleName = this.A.Navigator.GetCustomRouteData().ModuleName || '';
    constructor(A: ServiceBagService)
    {
        super(A, 'CommonSettingComponent', BaseEntity, State);
    }

    override OnInitTitle()
    {
        const title = this.A.Navigator.GetCustomRouteData().Title;
        if (title) { return this.RC(title); }
    }

    protected override OnInitState(): void
    {
        this.State.DataSourceName = this.A.Navigator.GetCustomRouteData().DataSource;
    }
}
